var _linearGradient, _linearGradient2, _radialGradient, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiscoverLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 107.2,
    height: 36.213,
    viewBox: "0 0 107.2 36.213",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "kuuq4ezwsa",
    x1: 60.786,
    y1: 1805.694,
    x2: 51.379,
    y2: 1790.641,
    gradientTransform: "translate(0 -1789.29)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f59f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.193,
    stopColor: "#f49b00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367,
    stopColor: "#f29101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496,
    stopColor: "#f08302"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598,
    stopColor: "#ee7905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759,
    stopColor: "#ec7008"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ec6d09"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gf3un4fmrb",
    x1: 60.786,
    y1: 1805.694,
    x2: 51.379,
    y2: 1790.641,
    gradientTransform: "translate(0 -1789.29)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3941e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.045,
    stopColor: "#f48c1c",
    stopOpacity: 0.076
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.198,
    stopColor: "#f77314",
    stopOpacity: 0.318
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#f95d0e",
    stopOpacity: 0.526
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    stopColor: "#fb4b09",
    stopOpacity: 0.696
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#fd3d05",
    stopOpacity: 0.829
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#fe3302",
    stopOpacity: 0.923
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#ff2d01",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff2b00"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "lacvcgp2ud",
    cx: 142.136,
    cy: 1663.494,
    r: 10.827,
    gradientTransform: "rotate(4.238 22316.593 -309.009) scale(.9945)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3941e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451,
    stopColor: "#ea8d1d",
    stopOpacity: 0.046
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664,
    stopColor: "#ca7618",
    stopOpacity: 0.205
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828,
    stopColor: "#924d10",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964,
    stopColor: "#441304",
    stopOpacity: 0.867
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    stopColor: "#2f0401",
    stopOpacity: 0.97
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "bg1sue69bc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.2 8.906a8.9 8.9 0 1 0 8.9-8.9 8.92 8.92 0 0 0-8.9 8.9",
    style: {
      fill: "none"
    }
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 31.006a5.189 5.189 0 0 1 5-5.2h.2a4.92 4.92 0 0 1 4.6 2.5l-1.4.8a3.311 3.311 0 0 0-3.2-1.9 3.671 3.671 0 0 0-3.7 3.6v.1a3.403 3.403 0 0 0 3.2 3.7H5a3.05 3.05 0 0 0 3.4-2.7H4.9v-1.4h4.9v5.4H8.3v-1.6l.1-.4a3.503 3.503 0 0 1-3.5 2.1 4.823 4.823 0 0 1-4.9-4.8zM11.6 25.206h1.5v10.8h-1.5zM14.6 32.306a3.9 3.9 0 1 1 3.9 3.9 3.842 3.842 0 0 1-3.9-3.9zm6.2 0a2.402 2.402 0 1 0-4.8.2 2.348 2.348 0 0 0 2.4 2.3 2.393 2.393 0 0 0 2.4-2.5zM25.2 34.906v1.1h-1.5v-10.9h1.5v4.5a3.17 3.17 0 0 1 2.5-1.2 3.853 3.853 0 0 1 0 7.7 2.897 2.897 0 0 1-2.5-1.2zm4.8-2.6a2.45 2.45 0 1 0-4.9-.1v.1a2.45 2.45 0 1 0 4.9 0zM32.6 34.106c0-1.5.9-2.1 2.9-2.4 1.4-.2 1.9-.3 1.9-.8s-.4-1.2-1.5-1.2a1.75 1.75 0 0 0-1.9 1.4l-1.4-.6a3.29 3.29 0 0 1 3.3-2.1c1.9 0 3.1 1 3.1 2.8v4.8h-1.4v-1.1a2.432 2.432 0 0 1-2.4 1.3c-1.6 0-2.6-.9-2.6-2.1zm4.3.2a1.613 1.613 0 0 0 .6-1.3v-.6c0 .3-.5.4-1.6.5-1.3.2-1.8.5-1.8 1.1 0 .5.5.9 1.2.9a2.452 2.452 0 0 0 1.6-.6zM40.6 25.206h1.5v10.8h-1.5zM47.2 26.006h1.6l5 7.6v-7.6h1.5v10.1h-1.5l-5.1-7.8v7.8h-1.5zM56.8 32.306a3.82 3.82 0 0 1 3.8-3.9h.1a3.689 3.689 0 0 1 3.8 3.6v.8h-6.3a2.485 2.485 0 0 0 3.1 1.9 3.088 3.088 0 0 0 1.6-1.1l1.2.7a3.814 3.814 0 0 1-3.4 1.8 3.716 3.716 0 0 1-3.9-3.6zm1.5-.7H63a2.177 2.177 0 0 0-2.3-1.8 2.281 2.281 0 0 0-2.4 1.8zM66.6 33.606v-3.7h-1.5v-1.3h1.5v-1.6l1.5-1v2.6h2v1.3H68v3.7c0 .8.4 1.2 1 1.2a2.016 2.016 0 0 0 1.1-.3v1.4a2.663 2.663 0 0 1-1.2.3c-1.5 0-2.3-.8-2.3-2.6zM71 28.606h1.5l1.7 5.4 2-5.4h1.4l2 5.4 1.8-5.4h1.5l-2.6 7.4h-1.4l-2-5.4-2.1 5.5h-1.5zM83.6 32.306a3.9 3.9 0 1 1 3.9 3.9 3.842 3.842 0 0 1-3.9-3.9zm6.2 0a2.402 2.402 0 0 0-4.8.2 2.348 2.348 0 0 0 2.4 2.3 2.393 2.393 0 0 0 2.4-2.5zM92.7 28.606h1.5v1.3a2.332 2.332 0 0 1 2.1-1.3h.6v1.5H96c-1.2 0-1.8.5-1.8 1.9v4h-1.5zM101.1 32.606l-1.3 1.4v1.9h-1.5v-10.7h1.5v7.2l3.5-3.8h1.8l-2.9 3.1 3 4.3h-1.7zM5.5.506H.7v16.8h4.8a9.166 9.166 0 0 0 6-1.9 8.315 8.315 0 0 0 3-6.4c0-5-3.7-8.5-9-8.5m3.9 12.6c-1 .9-2.4 1.3-4.5 1.3H4v-11h.9a6.088 6.088 0 0 1 4.5 1.4 5.598 5.598 0 0 1 1.8 4.2 5.94 5.94 0 0 1-1.8 4.1M16 .506h3.3v16.8H16zM27.3 7.006c-2-.7-2.5-1.2-2.5-2.1 0-1.1 1-1.9 2.4-1.9a3.143 3.143 0 0 1 2.6 1.4l1.7-2.2a7.523 7.523 0 0 0-4.9-1.9 4.914 4.914 0 0 0-5.2 4.6v.2c0 2.3 1.1 3.5 4.1 4.6a11.46 11.46 0 0 1 2.3 1 2.062 2.062 0 0 1 1 1.7 2.433 2.433 0 0 1-2.4 2.4h-.1a4.173 4.173 0 0 1-3.6-2.2l-2.1 2a6.501 6.501 0 0 0 5.8 3.2 5.44 5.44 0 0 0 5.8-5.5c-.1-2.8-1.2-4-4.9-5.3M33.2 8.906a8.621 8.621 0 0 0 8.6 8.7h.2a8.566 8.566 0 0 0 4.1-1v-3.8a4.977 4.977 0 0 1-3.9 1.8 5.464 5.464 0 0 1-5.6-5.3v-.5a5.595 5.595 0 0 1 5.4-5.8h.1a5.327 5.327 0 0 1 4.1 1.9v-3.7a7.924 7.924 0 0 0-4-1 8.713 8.713 0 0 0-9 8.7M72 11.806 67.5.506H64l7.1 17.2h1.7l7.3-17.2h-3.6l-4.5 11.3zM81.6 17.306h9.2v-2.8h-6v-4.6h5.8v-2.8h-5.8v-3.7h6v-2.9h-9.2v16.8zM103.8 5.506c0-3.1-2.2-4.9-5.9-4.9h-4.8v16.8h3.3v-6.8h.4l4.5 6.7h4l-5.3-7.1a4.404 4.404 0 0 0 3.8-4.7m-6.6 2.8h-1v-5.1h1c2 0 3.1.9 3.1 2.5.1 1.7-1 2.6-3.1 2.6M106.4 1.406c0-.3-.2-.5-.6-.5h-.5v1.5h.4v-.5l.4.6h.4l-.4-.7c.2 0 .3-.2.3-.4m-.6.2-.1-.4h.1c.2 0 .3.1.3.2-.1.2-.2.2-.3.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.9.406a1.324 1.324 0 0 0-1.3 1.3 1.3 1.3 0 0 0 2.6 0 1.324 1.324 0 0 0-1.3-1.3m0 2.4a1.028 1.028 0 0 1-1.1-1 1.051 1.051 0 1 1 2.1-.1 1.09 1.09 0 0 1-1 1.1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.2 8.906a8.9 8.9 0 1 0 8.9-8.9 8.92 8.92 0 0 0-8.9 8.9",
    style: {
      fill: "url(#kuuq4ezwsa)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2 8.906a8.9 8.9 0 1 0 8.9-8.9 8.92 8.92 0 0 0-8.9 8.9",
    style: {
      fill: "url(#gf3un4fmrb)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#bg1sue69bc)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.2 9.306a10.9 10.9 0 1 0 10.9-10.9 10.926 10.926 0 0 0-10.9 10.9",
    style: {
      fill: "url(#lacvcgp2ud)"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverLogo);
export default __webpack_public_path__ + "static/media/discover_logo.49840fb434eb1509aa02ab1a0d1c8760.svg";
export { ForwardRef as ReactComponent };